import { AppEnvironment } from '../enums/appEnvironment.enum'

const KNOWN_ENVIRONMENTS = new Set<AppEnvironment>([
  AppEnvironment.LOCALHOST,
  AppEnvironment.DEV,
  AppEnvironment.TEST,
  AppEnvironment.PROD,
])

export function getAppEnvironment(): AppEnvironment | undefined {
  const env = process.env.NEXT_PUBLIC_APP_ENV as AppEnvironment

  if (!KNOWN_ENVIRONMENTS.has(env)) {
    return undefined
  }

  return env
}

export function isProduction(): boolean {
  return getAppEnvironment() === AppEnvironment.PROD
}

export function isTest(): boolean {
  return getAppEnvironment() === AppEnvironment.TEST
}

export function isDevEnvironment(): boolean {
  const env = getAppEnvironment()

  return env === AppEnvironment.LOCALHOST || env === AppEnvironment.DEV
}
